import React, { useEffect, useState } from "react";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import {
  Card,
  CardBody,
  Col,
  Container,
  Input,
  Label,
  Row,
  Button,
  Spinner,
} from "reactstrap";
import { Link, useNavigate } from "react-router-dom";
import { getSellerMe, postSellerWithdrawal } from "../../../api/ecommerce";
import { toast, ToastContainer } from "react-toastify";

const WithdrawRequest = () => {
  const navigate = useNavigate();
  const [amount, setAmount] = useState("");
  const [sellerNote, setSellerNote] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [loadingBank, setLoadingBank] = useState(true);
  const [bankSeller, setBankSeller] = useState(null);

  const backToList = "/seller-draw";

  useEffect(() => {
    document.title = "New Withdrawal Request | TopCoinLand";
  }, []);

  useEffect(() => {
    let cancelled = false;
    getSellerMe()
      .then((row) => {
        if (cancelled) return;
        setBankSeller(row && typeof row === "object" ? row : null);
      })
      .catch(() => {
        if (!cancelled) setBankSeller(null);
      })
      .finally(() => {
        if (!cancelled) setLoadingBank(false);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  const handleWithdraw = async () => {
    const amt = parseFloat(String(amount).replace(/,/g, ""));
    if (!Number.isFinite(amt) || amt <= 0) {
      toast.error("Enter a valid amount greater than zero.");
      return;
    }
    setSubmitting(true);
    try {
      await postSellerWithdrawal({
        amount: amt,
        currency: "GBP",
        seller_note: sellerNote?.trim() || null,
      });
      toast.success("Withdrawal request submitted.");
      navigate(backToList);
    } catch (err) {
      toast.error(err?.error || err?.message || "Could not submit request.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="page-content">
      <Container fluid>
        <BreadCrumb title="Withdraw Request" pageTitle="Seller" />

        <Row className="mb-2">
          <Col>
            <Button color="link" className="ps-0" tag={Link} to={backToList}>
              <i className="ri-arrow-left-line me-1" /> Back to withdrawals
            </Button>
          </Col>
        </Row>

        <Row>
          <Col lg={12}>
            <Card>
              <CardBody>
                <h5 className="card-title mb-3">New withdrawal request</h5>

                <Row className="mt-2">
                  <Col md={12}>
                    <Label>Amount ({bankSeller?.wallet_balance != null ? `balance £${Number(bankSeller.wallet_balance).toFixed(2)}` : "GBP"})</Label>
                    <Input
                      type="number"
                      min="0"
                      step="0.01"
                      className="mb-3"
                      placeholder="Enter amount"
                      value={amount}
                      onChange={(e) => setAmount(e.target.value)}
                    />
                  </Col>

                  <Col md={12}>
                    <Label>Note (optional)</Label>
                    <Input
                      type="textarea"
                      rows={3}
                      className="mb-3"
                      placeholder="Any note for the admin"
                      value={sellerNote}
                      onChange={(e) => setSellerNote(e.target.value)}
                    />
                  </Col>

                  <Col md={12}>
                    <Button color="primary" onClick={handleWithdraw} disabled={submitting}>
                      {submitting ? (
                        <>
                          <Spinner size="sm" className="me-2" /> Submitting...
                        </>
                      ) : (
                        "Request withdraw"
                      )}
                    </Button>
                  </Col>
                </Row>

                <Card className="border bg-light mt-4">
                  <CardBody>
                    <p className="fw-medium mb-3">Payout bank details (on file)</p>
                    {loadingBank ? (
                      <Spinner size="sm" />
                    ) : bankSeller ? (
                      <div className="d-flex flex-wrap justify-content-between gap-3">
                        <div>
                          <label className="text-dark text-opacity-50 text-uppercase small d-block">Bank name</label>
                          <p className="mb-0">{bankSeller.bank_name || "—"}</p>
                        </div>
                        <div>
                          <label className="text-dark text-opacity-50 text-uppercase small d-block">Branch</label>
                          <p className="mb-0">{bankSeller.branch || "—"}</p>
                        </div>
                        <div>
                          <label className="text-dark text-opacity-50 text-uppercase small d-block">Account holder</label>
                          <p className="mb-0">{bankSeller.account_holder_name || "—"}</p>
                        </div>
                        <div>
                          <label className="text-dark text-opacity-50 text-uppercase small d-block">Account number</label>
                          <p className="mb-0">{bankSeller.account_number || "—"}</p>
                        </div>
                        <div>
                          <label className="text-dark text-opacity-50 text-uppercase small d-block">IFSC / Sort code</label>
                          <p className="mb-0">{bankSeller.ifsc_code || "—"}</p>
                        </div>
                      </div>
                    ) : (
                      <p className="text-muted mb-0">
                        Complete your seller profile with bank details so payouts can be processed.
                      </p>
                    )}
                  </CardBody>
                </Card>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
      <ToastContainer position="top-right" autoClose={4000} />
    </div>
  );
};

export default WithdrawRequest;
